import { render } from "./BlockCountdownEdit.vue?vue&type=template&id=241a3d34"
import script from "./BlockCountdownEdit.vue?vue&type=script&lang=js"
export * from "./BlockCountdownEdit.vue?vue&type=script&lang=js"
script.render = render

export default script